import { Center, Stack } from '@chakra-ui/react'
import { Newsletter } from 'client/components/landing/newsletter'
import { PublicNavHeader } from 'client/components/nav/publicNavHeader'
import { PublicPage } from 'client/layouts/pages/publicPage'
import { DimmedText } from 'modules/ui/typography/dimmedText'
import { NextPage } from 'next'
import React from 'react'

const ToSPage: NextPage = () => {
  return (
    <PublicPage
      title="Terms of Service"
      description="End-to-end encrypted privacy-first web analytics"
      openGraph={
        {
          // todo: Add og:image
        }
      }
    >
      <PublicNavHeader />
      <Center h="xs">
        <Stack>
          <DimmedText>🚧 This page is under construction.</DimmedText>
          <Newsletter source="tos" />
        </Stack>
      </Center>
    </PublicPage>
  )
}

export default ToSPage
